import React from "react";
import { useState, useEffect } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./styles/theme";
import Topbar from "../src/pages/scenes/global/Topbar";
import Sidebar from "../src/pages/scenes/global/Sidebar";
import RouterConfig from "./navigation/RouterConfig";
import { LicenseInfo } from "@mui/x-license-pro";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
LicenseInfo.setLicenseKey("YOUR_LICENSE_KEY");
function App() {
  const navigate = useNavigate();
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  // useEffect(() => {
  //   const toggleButton = document.querySelector('.pro-icon-wrapper');
  //   const sidebar = document.querySelector('.pro-sidebar');
  //   const mainDiv = document.querySelector('.main-div');
  //   const top = document.querySelector('.navbar-div-expanded');
  //   const table = document.querySelector('.content > div:nth-child(2)');

  //   console.log(table,'table');
  //   if (toggleButton && sidebar && mainDiv) {
  //     toggleButton.addEventListener('click', function () {
  //       sidebar.classList.toggle('collapsed');
  //       if (sidebar.classList.contains('collapsed')) {
  //         mainDiv.classList.remove('main-div-expanded');
  //         top.classList.remove('navbar-div-expanded');
  //         mainDiv.classList.add('main-div-collapsed');
  //         top.classList.add('navbar-div-collapsed');
  //         table.classList.add('css-zjqymt-collapsed');
  //       } else {
  //         mainDiv.classList.remove('main-div-collapsed');
  //         top.classList.remove('navbar-div-collapsed');
  //         table.classList.remove('css-zjqymt-collapsed');
  //         mainDiv.classList.add('main-div-expanded');
  //         top.classList.add('navbar-div-expanded');
  //       }
  //     });
  //   }

  //   // Cleanup function
  //   return () => {
  //     if (toggleButton) {
  //       toggleButton.removeEventListener('click', function () {
  //         sidebar.classList.toggle('collapsed');
  //         if (sidebar.classList.contains('collapsed')) {
  //           mainDiv.classList.remove('main-div-expanded');
  //           top.classList.remove('navbar-div-expanded');
  //           mainDiv.classList.add('main-div-collapsed');
  //           top.classList.add('navbar-div-collapsed');
  //           table.classList.add('css-zjqymt-collapsed');
  //         } else {
  //           mainDiv.classList.remove('main-div-collapsed');
  //           top.classList.remove('navbar-div-collapsed');
  //           table.classList.remove('css-zjqymt-collapsed');
  //           mainDiv.classList.add('main-div-expanded');
  //           top.classList.add('navbar-div-expanded');
  //         }
  //       });
  //     }
  //   };
  // });
  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
        {JSON.parse(localStorage.getItem("is loggedIn")) == true ?(

          <Sidebar />
        ):(
<></>
        )}
          <main className="content">
          {JSON.parse(localStorage.getItem("is loggedIn"))=== true ?(

            <Topbar setIsSidebar={setIsSidebar} />

                ):(
                <></>
                )}
            <RouterConfig></RouterConfig>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
